import {
  questionnaireMap,
  type MonarchQuestionnaireName,
} from '../constants/questionnaires/questionnaireMap'

/**
 * Type guard to validate if a value is a valid questionnaire name.
 * Checks if the value is a string and exists as a key in the questionnaireMap.
 *
 * @param value - The value to validate
 * @returns True if the value is a valid MonarchQuestionnaireName, false otherwise
 *
 * @example
 * ```typescript
 * const value = 'default'
 * if (isValidQuestionnaireName(value)) {
 *   // value is now typed as MonarchQuestionnaireName
 *   const questionnaire = questionnaireMap[value]
 * }
 * ```
 */
export const isValidQuestionnaireName = (value: unknown): value is MonarchQuestionnaireName => {
  return typeof value === 'string' && value in questionnaireMap
}
